import AllActions from "@/infrastructure/rootAction";

import produce from "immer";
import { getType } from "typesafe-actions";

import { fetchCacheKeysAsync, updateAppInfo, updateAuthToken, updateUserInfo, updateUserInfoLoading } from "./actions";
import { defaultState } from "./defaults";

export default (state = defaultState, action: AllActions) =>
  produce(state, draft => {
    switch (action.type) {
      case getType(updateAppInfo):
        draft.appInfo = action.payload;
        break;

      case getType(updateAuthToken):
        draft.authToken = action.payload;
        break;

      case getType(updateUserInfo):
        draft.userInfo = { ...state.userInfo, ...action.payload };
        break;

      case getType(updateUserInfoLoading):
        draft.loading.userInfo = action.payload;
        break;

      case getType(fetchCacheKeysAsync.request):
        draft.loading.cache = "REQUEST";
        break;

      case getType(fetchCacheKeysAsync.failure):
        draft.loading.cache = "FAILURE";
        break;
      case getType(fetchCacheKeysAsync.success):
        draft.loading.cache = "SUCCESS";
        draft.cache = action.payload;
        break;
    }
  });
